import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SetMeeting from "./setMeeting";
import "./aboutMe.css";
import { height } from "@fortawesome/free-solid-svg-icons/fa0";

const MyResume = () => (
  <div className="resume">
    <div className="resumeBotton">
      <a href="/resume">
        {/* <button type='metting'> */}
        My Resume
        {/* </button> */}
        <hr />
      </a>
    </div>
  </div>
);

const AboutMe = () => {
  const [isHoveringIran, setIsHoveringIran] = useState(false);
  const timeoutRef = useRef(null);
  const navigate = useNavigate();

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setIsHoveringIran(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsHoveringIran(false);
    }, 300); // 300ms delay before hiding
  };

  const handleCuneiformClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate("/iran");
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div className="container">
      <div style={{ display: "flex", alignItems: "start", gap: "2rem" }}>
        <div style={{ flex: 2.5, paddingTop: "2rem" }}>
          <h1 className="title" style={{ fontSize: "32", marginTop: "3rem" }}>
            Danial M.
          </h1>
          {/* <h2 className="subtitle">Software Developer</h2> */}
          {/* <p className="contactinfo">
          Email: <a href="mailto:danial@danials.org">danial@danials.org</a>
        </p> */}
          <div className="subtitle">Software Developer</div>
          {/* <div className="subtitle">
          Flutter & Golang Developer
        </div> */}
          {/* <p className="contactinfo">Website: <a href="https://website.danials.org">danials.org</a></p> */}
          {/* <h3 className="subtitle">About Me</h3> */}
          <p className="description">
            I'm a software developer based in{" "}
            <span
              className="highlight iran-hover-container"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{ position: "relative", cursor: "pointer" }}
            >
              Iran
              {isHoveringIran && (
                <span
                  className="cuneiform-tooltip"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  // onClick={handleCuneiformClick}
                  style={{ cursor: "pointer" }}
                >
                  <span className="cuneiform-text">𐎱𐎠𐎼𐎿𐎠</span>
                </span>
              )}
            </span>
            , specializing in <span className="highlight">Flutter</span> and{" "}
            <span className="highlight">Golang</span>, building fast, secure,
            and user-friendly applications. I've worked on mobile apps, back-end
            systems, and real-time communication tools.
          </p>
          {/* <div className="SetMeetingAndMyResume">
          <SetMeeting />
          <MyResume />
        </div> */}
        </div>
        <div style={{ flex: 1 }} className="profileImage">
          <img
            src="./wewe.jpg"
            alt="Profile"
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
